import { render } from "./BaseRotator.vue?vue&type=template&id=0f6a6a98&scoped=true"
const script = {}

import "./BaseRotator.vue?vue&type=style&index=0&id=0f6a6a98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f6a6a98"]])

export default __exports__